// extracted by mini-css-extract-plugin
export default {"header":"_header_header__lqORw"};